import { render, staticRenderFns } from "./journey.vue?vue&type=template&id=3a60f670&scoped=true&"
import script from "./journey.vue?vue&type=script&lang=js&"
export * from "./journey.vue?vue&type=script&lang=js&"
import style0 from "./journey.vue?vue&type=style&index=0&id=3a60f670&lang=less&scoped=true&"
import style1 from "./journey.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60f670",
  null
  
)

export default component.exports